<h1 mat-dialog-title>Tierliste zu Gruppe {{ gruppe?.bezeichnung }} hochladen</h1>
<div mat-dialog-content>
    <div style="margin-bottom: 12px">
        <p class="one-row" style="font-weight: bolder">Beispielaufbau der Excel-Tierliste:</p>
        <div class="info-box">
            <table style="border-collapse: collapse; border-spacing: 0; width: 100%">
                <tr style="">
                    <td style="color: #c5dece"></td>
                    <td style="background-color: #c5ccb6; border: 2px solid black; color: transparent; width: 15px">
                    </td>
                    <td style="background-color: #c5ccb6; border: 2px solid black; text-align: center; width: 150px">
                        A
                    </td>
                    <td
                        style="
                            background-color: #c5ccb6;
                            border: 2px solid black;
                            border-right: none;
                            text-align: center;
                            width: 15px;
                        "
                    ></td>
                </tr>
                <tr>
                    <td style="width: 250px"><strong>Zeile 1</strong>: Reserviert für Überschrift</td>
                    <td style="background-color: #c5ccb6; border: 2px solid black">1</td>
                    <td style="border: 2px solid black"><strong>Ohrmarke</strong></td>
                    <td style="border: 2px solid black; border-right: none"></td>
                </tr>
                <tr>
                    <td><strong>Ab Zeile 2</strong>: in Spalte A Ohrmarke eintragen</td>
                    <td style="background-color: #c5ccb6; border: 2px solid black">2</td>
                    <td style="border: 2px solid black">276000362853465</td>
                    <td style="border: 2px solid black; border-right: none"></td>
                </tr>
                <tr>
                    <td
                        ><span style="font-style: italic"
                            >Ohrmarke als 15-, 12- oder 10-stelliges Format eintragen</span
                        ></td
                    >
                    <td style="background-color: #c5ccb6; border: 2px solid black">3</td>
                    <td style="border: 2px solid black">0363200490</td>
                    <td style="border: 2px solid black; border-right: none"></td>
                </tr>
                <tr>
                    <td></td>
                    <td style="background-color: #c5ccb6; border: 2px solid black">3</td>
                    <td style="border: 2px solid black">DE0363394527</td>
                    <td style="border: 2px solid black; border-right: none"></td>
                </tr>
            </table>
        </div>
        <div class="one-row">
            <div *ngFor="let file of filesToUpload" class="one-row" style="width: 80%">
                <mat-icon style="color: gray">description</mat-icon>
                <span style="margin-left: 12px">{{ file?.name }}</span>
                <span class="spacer"></span>
            </div>
            <span class="spacer"></span>
            <button mat-stroked-button color="accent" (click)="openFileSelector()">
                <mat-icon>attach_file</mat-icon>
                Dateien ausw&auml;hlen
            </button>
            <input
                type="file"
                style="display: none"
                #fileSelector
                (change)="handleFile($event)"
                accept=".csv, .xls, .xlsx"
            />
        </div>

        <mat-form-field style="width: 100%; margin-top: 12px">
            <mat-label>Einstalldatum</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="einstalldatumCtrl" required [readonly]="true" />

            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <mat-label>Viehh&auml;ndler</mat-label>
            <mat-select [formControl]="viehhaendlerCtrl" [disabled]="selectedBetriebskontakt !== null">
                <mat-option *ngFor="let v of viehhaendler" [value]="v">{{ v.name }}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- "Oder" Text -->
        <div
            *ngIf="!selectedBetriebskontakt && (!viehhaendlerCtrl.value || !viehhaendlerCtrl.value.viehhaendler_id)"
            style="text-align: center; margin: 16px 0; color: #666; font-weight: 500"
        >
            Oder
        </div>

        <!-- Betriebskontakt-Auswahl -->
        <div style="margin-bottom: 16px" *kienePermission="[9601]">
            <!-- Auswahl-Dialog (nur anzeigen wenn kein Kontakt ausgewählt und kein Händler ausgewählt) -->
            <div *ngIf="!selectedBetriebskontakt && (!viehhaendlerCtrl.value || !viehhaendlerCtrl.value.viehhaendler_id)">
                <kiene-betriebskontakt-auswahl
                    [config]="{
                        showHaendler: true,
                        showLandwirte: true,
                        showSchlachthoefe: true,
                        showAll: true,
                        multiSelect: false,
                        compact: true,
                        title: '',
                        placeholder: 'Kontakt auswählen...',
                        allowCreateNew: true,
                        keepOpenOnSelect: false
                    }"
                    [selectedKontakte]="[]"
                    (kontaktSelected)="onBetriebskontaktSelected($event)"
                ></kiene-betriebskontakt-auswahl>
            </div>

            <!-- Anzeige der ausgewählten Kontakt-Card -->
            <div *ngIf="selectedBetriebskontakt" style="margin-top: 16px">
                <kiene-betriebskontakt-card
                    [kontakt]="selectedBetriebskontakt"
                    [config]="{
                        showActions: true,
                        showMenu: false,
                        showFavorit: false,
                        showBadge: true,
                        compact: false,
                        selectedMode: true
                    }"
                    (entfernen)="onBetriebskontaktEntfernen()"
                >
                </kiene-betriebskontakt-card>
            </div>
        </div>

        <mat-form-field style="width: 100%">
            <mat-label>Abteil</mat-label>
            <input matInput type="text" [formControl]="abteilCtrl" />
        </mat-form-field>

        <mat-form-field style="width: 100%; margin-bottom: 6px" class="no-padding-margin-mat-form-field">
            <mat-label>Bemerkung</mat-label>
            <textarea [disabled]="isLoading" matInput [formControl]="bemerkungCtrl" rows="3"></textarea>
        </mat-form-field>

        <div class="one-row">
            <span>Nach dem Hochladen direkt an HIT melden?: *</span>
            <span class="spacer"></span>
            <mat-radio-group [formControl]="hitMeldenCtrl" required>
                <mat-radio-button [value]="1">ja</mat-radio-button>
                <mat-radio-button [value]="0">nein</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button
        mat-flat-button
        color="accent"
        (click)="uploadFilesToServer()"
        [disabled]="
            isLoading || filesToUpload?.length === 0 || !einstalldatumCtrl.value || hitMeldenCtrl.value === undefined
        "
    >
        Hochladen
    </button>
</div>
